export default {"src":"/_next/static/media/linkdin-icon.10d29d67.svg","height":512,"width":448,"blurWidth":0,"blurHeight":0};